/* apiKey = backend field for the main answer. For multiselect-textarea (two headings), use apiKey for selected medications and apiKey2 for the condition textarea. See collectApiPayload / window.gadAssessmentGetApiPayload in assessment-engine.js */
window.assessmentConfig = {
  loginUrl: "https://account.getadrip.shop/login",
  questions: [
    {
      id: "q1",
      apiKey: "used_ed_treatment_with_us_before",
      type: "selector",
      progress: null,
      showBack: false,
      heading: "Have you used ED treatment with us before?",
      subheading: "Have you had an ED prescription with us?",
      showButton: true,
      buttonLabel: "Continue",
      options: [
        { label: "Yes", value: "yes", next: "q2" },
        { label: "No", value: "no", next: "q2" }
      ]
    },
    {
      id: "q2",
      apiKey: null,
      type: "agreement",
      progress: null,
      showBack: true,
      heading: "Do you agree to the following?",
      bulletPoints: [
        "I was assigned male at birth and I'm having difficulty getting or maintaining an erection.",
        "I'm truthfully answering these questions for myself, and I understand that providing false information could lead to harm or even death.",
        "I'll only use treatment as directed by my prescribing clinician, and I'll disclose any medical conditions I have and medication I take.",
        {
          html:
            'I accept the <a class="assessment__agreement-link" href="https://getadrip.shop/pages/terms-conditions#:~:text=A)%20Get%20A%20Drip%20%2D%20Terms%20and%20Conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>, <a class="assessment__agreement-link" href="https://getadrip.shop/pages/terms-of-sale#:~:text=B)%20Get%20A%20Drip%20%2D%20Terms%20of%20Sale" target="_blank" rel="noopener noreferrer">Terms of Sale</a>, and confirm that I have read the <a class="assessment__agreement-link" href="https://getadrip.shop/pages/privacy-policy#:~:text=C)%20Get%20A%20Drip%20%2D%20Privacy%20Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.'
        },
        "Reviewed by a UK registered Prescriber. We can only prescribe if safe, if not we'll signpost."
      ],
      buttonLabel: "Confirm",
      next: "q4"
    },
    {
      id: "q2-welcome",
      apiKey: null,
      type: "selector",
      progress: 0,
      showBack: true,
      heading: "Welcome back! Would you like to reorder your previous treatment or explore new options?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Reorder my previous treatment", value: "reorder", next: "q4a" },
        { label: "Explore new treatment options", value: "explore", next: "q4" }
      ]
    },
    {
      id: "q4",
      apiKey: "age_range",
      type: "selector",
      progress: 1,
      showBack: true,
      heading: "What is your age?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Under 18", value: "under-18", next: "not-eligible" },
        { label: "18 to 25", value: "18-25", next: "q4b" },
        { label: "26-64", value: "26-64", next: "q4b", boldLabel: true },
        { label: "65-69", value: "65-69", next: "q4b" },
        { label: "70 or over", value: "70-plus", next: "q4b" }
      ]
    },
    {
      id: "q4a",
      apiKey: "ed_history_statements",
      type: "selector",
      progress: 0,
      showBack: true,
      heading: "Choose the statement that best applies to you",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "I have never had an erection", value: "never-erection", next: "not-eligible" },
        { label: "I have been able to maintain an erection in the past, but now I cannot reliably maintain an erection", value: "erection-issues", next: "q5" }
      ]
    },
    {
      id: "q4b",
      apiKey: "blood_pressure_checked_past_6_months",
      type: "selector",
      progress: 0,
      showBack: true,
      heading: "Have you had your blood pressure checked in past 6 months?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "No", value: "no", next: "q4a" },
        { label: "Yes", value: "yes", next: "q4c" }
      ]
    },
    {
      id: "q4c",
      apiKey: "blood_pressure_category",
      type: "selector",
      progress: 4,
      showBack: true,
      heading: "What was your blood pressure?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Less than 90/50 mmHg (Low)", value: "bp-low", next: "not-eligible" },
        { label: "Between 90/50 and 140/90 mmHg (normal)", value: "bp-normal", next: "q4d" },
        { label: "Over 140/90 mmHg (High)", value: "bp-high", next: "not-eligible" }
      ]
    },
    {
      id: "q4d",
      apiKey: "blood_pressure_medication",
      type: "selector",
      progress: 4,
      showBack: true,
      heading: "Do you take any medication for your blood pressure?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "q4e" },
        { label: "No", value: "no", next: "q4a" }
      ]
    },
    {
      id: "q4e",
      apiKey: "blood_pressure_medication_details",
      type: "textarea",
      progress: 4,
      showBack: true,
      heading: "Tell about medication for your blood pressure?",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q4a"
    },
    {
      id: "q5",
      apiKey: "allergies",
      type: "multiselect-selector",
      exclusiveValues: ["none", "other"],
      progress: 8,
      showBack: true,
      heading: "Are you allergic to any of the following medication(s)?",
      buttonLabel: "Next",
      next: "q6",
      options: [
        { label: "Sildenafil (Viagra)", value: "sildenafil" },
        { label: "Tadalafil (Cialis)", value: "tadalafil" },
        { label: "Vardenafil (Levitra)", value: "vardenafil" },
        { label: "Avanafil (Spedra)", value: "avanafil" },
        { label: "Lactose intolerance only", value: "lactose" },
        { label: "Other allergy", value: "other" },
        { label: "None", value: "none" }
      ]
    },
    {
      id: "q5a",
      apiKey: "lactose_tolerance",
      type: "selector",
      progress: 9,
      showBack: true,
      heading: "ED tablets may contain a very small amount of lactose. Please select the option that best applies to you:",
      bulletPoints: [
        "I have no issues with small amounts of lactose.",
        "I am lactose intolerant but can tolerate very small amounts.",
        "I cannot tolerate lactose and would prefer a lactose-free option."
      ],
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "I can't tolerate any amount of lactose", value: "no-lactose", next: "q6" },
        { label: "I can tolerate very small amounts of lactose", value: "some-lactose", next: "q6" }
      ]
    },
    {
      id: "q5b",
      apiKey: "other_allergy_details",
      type: "textarea",
      progress: 9,
      showBack: true,
      heading: "Please state your allergy",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q6"
    },
    {
      id: "q6",
      apiKey: "weight",
      type: "weight-slider",
      progress: 10,
      showBack: true,
      heading: "What is your weight? (Help us assess general health.)",
      buttonLabel: "Next",
      next: "q6a"
    },
    {
      id: "q6a",
      apiKey: "height",
      type: "height-slider",
      progress: 12,
      showBack: true,
      heading: "What is your height?",
      buttonLabel: "Next",
      next: "q7"
    },
    {
      id: "q7",
      apiKey: "review_statements",
      type: "multiselect-selector",
      exclusiveValues: ["none"],
      progress: 14,
      showBack: true,
      heading: "Select all of the following statements that apply to you. Some conditions need extra review, many men can be treated safely.",
      buttonLabel: "Next",
      next: "q15",
      options: [
        { label: "I have been advised to refrain from strenuous activity, such as sex", value: "refrain-activity" },
        { label: "I get chest pain or shortness of breath walking short distances, or up a flight of stairs", value: "chest-pain" },
        { label: "I have had a heart attack / myocardial infarction or stroke / transient ischaemic attack (TIA) in the last 6 months", value: "heart-attack" },
        { label: "I have been diagnosed with a cardiovascular disease (e.g. cardiomyopathy)", value: "cardiovascular-disease" },
        { label: "I have a liver or kidney impairment", value: "liver-kidney" },
        { label: "I am awaiting an organ transplant", value: "organ-transplant" },
        { label: "I suffer from a hereditary degenerative retinal disorder", value: "retinal-disorder" },
        { label: "I have a history of non-arteritic anterior ischaemic optic neuropathy", value: "optic-neuropathy" },
        { label: "My doctor informed me that I have high or low blood pressure", value: "blood-pressure" },
        { label: "My doctor informed me that I have an irregular heartbeat", value: "irregular-heartbeat" },
        { label: "I suffer from any of the following: sickle cell anaemia, myeloma or leukaemia", value: "blood-disorder" },
        { label: "I suffer from penile deformity, angulation, or have been diagnosed with peyronie's disease", value: "penile-deformity" },
        { label: "None of the above", value: "none" }
      ]
    },
    {
      id: "q7a",
      apiKey: "unstable_angina_or_heart_failure",
      type: "selector",
      progress: 15,
      showBack: true,
      heading: "Have you been diagnosed with unstable angina or heart failure?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "not-eligible" },
        { label: "No", value: "no", next: "q7b" }
      ]
    },
    {
      id: "q7b",
      apiKey: "chest_pain_or_sob_details",
      type: "textarea",
      progress: 17,
      showBack: true,
      heading: "Please tell us more about your chest pain or shortness of breath, including:",
      bulletPoints: [
        "What happens when you experience it",
        "If you've consulted a doctor about it",
        "What the outcome of that consultation was"
      ],
      subheading: "Tell us about symptoms and any diagnosis/medications?",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q8",
      apiKey: "liver_kidney_impairment_details",
      type: "textarea",
      progress: 18,
      showBack: true,
      heading: "Please tell us more about your liver or kidney impairment, as well as the results of your most recent liver and/or kidney",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q9",
      apiKey: "transplant_details",
      type: "textarea",
      progress: 19,
      showBack: true,
      heading: "Please tell us about your transplant type, timing and current medicines?",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q10",
      apiKey: "retinal_disorder_details",
      type: "textarea",
      progress: 19,
      showBack: true,
      heading: "Please tell us more about your hereditary degenerative retinal disorder, please include the specific diagnosis and any treatment or medication you receive for your hereditary retinal disorder.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q11",
      apiKey: "irregular_heartbeat_symptoms",
      type: "selector",
      progress: 29,
      showBack: true,
      heading: "Are you still experiencing any symptoms of irregular heartbeat, such as palpitations, or shortness of breath?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "not-eligible" },
        { label: "No", value: "no", next: "q11b" }
      ]
    },
    {
      id: "q11c",
      apiKey: "blood_disorder_condition_details",
      type: "textarea",
      progress: 29,
      showBack: true,
      heading: "Which of the three conditions (sickle cell anaemia, myeloma or leukaemia) do you have? Please tell us more about your condition including any treatments or medications you receive for your condition.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q11a",
      apiKey: "priapism_risk_acceptance",
      type: "selector",
      progress: 29,
      showBack: true,
      heading: "Sickle cell anaemia, multiple myeloma and leukaemia may predispose to priapism (a prolonged erection)",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "I accept the risk that sickle cell anaemia, multiple myeloma and leukaemia may predispose to priapism (a prolonged erection) and would like to proceed", value: "accept", next: "q11c" },
        { label: "I do not accept the risk and do not wish to proceed", value: "decline", next: "not-eligible" }
      ]
    },
    {
      id: "q11b",
      apiKey: "irregular_heartbeat_details_blood_disorder",
      type: "textarea",
      progress: 29,
      showBack: true,
      heading: "Please tell us more about your irregular heartbeat, including your specific diagnosis (e.g. atrial fibrillation, cardiac arrhythmia), and any treatment or medication you receive for your irregular heartbeat.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q12",
      apiKey: "palpitations_dizziness_fainting_or_sob",
      type: "selector",
      progress: 29,
      showBack: true,
      heading: "Do you currently have palpitations, dizziness, fainting or shortness of breath?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "not-eligible" },
        { label: "No", value: "no", next: "q12a" }
      ]
    },
    {
      id: "q12a",
      apiKey: "irregular_heartbeat_details",
      type: "textarea",
      progress: 29,
      showBack: true,
      heading: "Please tell us more about your irregular heartbeat, including your specific diagnosis (e.g. atrial fibrillation, cardiac arrhythmia), and any treatment or medication your receive for your irregular heartbeat.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q13",
      apiKey: "blood_disorder_details",
      type: "textarea",
      progress: 29,
      showBack: true,
      heading: "Which of three conditions (sickle cell anaemia, myeloma or leukaemia) do you have? Please tell us more about your condition including any treatments or medications you receive for your condition.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q14",
      apiKey: "penile_deformity_details",
      type: "textarea",
      progress: 31,
      showBack: true,
      heading: "Please tell us more about your penile deformity, angulation or peyronie\u2019s disease including:",
      bulletPoints: [
        "If you\u2019ve seen a doctor about it",
        "If you\u2019re taking any treatment or medications for it",
        "If it interferes with your ability to get an erection or ability to have sexual intercourse"
      ],
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q15"
    },
    {
      id: "q15",
      apiKey: "meds_recreational_drugs",
      type: "multiselect-selector",
      exclusiveValues: ["none"],
      progress: 32,
      showBack: true,
      heading: "Do you take any of the following medications or recreational drugs?",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Nicorandil and/or riociguat / glyceryl trinitrate (GTN) spray / isosorbide mononitrate (ISMN) / dinitrate / amyl nitrate (poppers)", value: "nitrates-poppers" },
        { label: "Cimetidine / indoramin / erythromycin / clarithromycin / fluconazole / itraconazole / ketoconazole / miconazole / voriconazole", value: "cyp-inhibitors" },
        { label: "Citalopram / escitalopram", value: "ssri" },
        { label: "Rifampicin / indinavir / tipranavir / atazanavir / darunavir / fosamprenavir /saquinavir", value: "hiv-protease" },
        { label: "Doxazosin / tamsulosin / alfuzosin / terazosin / prazosin", value: "alpha-blockers" },
        { label: "Diltiazem / verapamil / amiodarone", value: "calcium-channel" },
        { label: "Nilotinib / lapatinib / pazopanib / sunitinib", value: "kinase-inhibitors" },
        { label: "None of the above", value: "none" }
      ]
    },
    {
      id: "q15a",
      apiKey: "meds_cimetidine_azole_macrolide_selected",
      apiKey2: "meds_cimetidine_azole_macrolide_details",
      type: "multiselect-textarea",
      progress: 36,
      showBack: true,
      heading: "Please tell us which of these medications you take",
      heading2: "What condition you are using it to treat.",
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Cimetidine", value: "cimetidine" },
        { label: "Indoramin", value: "indoramin" },
        { label: "Erythromycin", value: "erythromycin" },
        { label: "Clarithromycin", value: "clarithromycin" },
        { label: "Fluconazole", value: "fluconazole" },
        { label: "Itraconazole", value: "itraconazole" },
        { label: "Ketoconazole", value: "ketoconazole" },
        { label: "Miconazole", value: "miconazole" },
        { label: "Voriconazole", value: "voriconazole" }
      ]
    },
    {
      id: "q16",
      apiKey: "meds_citalopram_escitalopram_selected",
      apiKey2: "meds_citalopram_escitalopram_details",
      type: "multiselect-textarea",
      progress: 37,
      showBack: true,
      heading: "Please tell us which of these medications you take",
      heading2: "What condition you are using it to treat.",
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Citalopram", value: "citalopram" },
        { label: "Escitalopram", value: "escitalopram" }
      ]
    },
    {
      id: "q17",
      apiKey: "meds_rifampicin_hiv_pi_details",
      type: "textarea",
      progress: 39,
      showBack: true,
      heading: "Please tell us which of these medications you take (rifampicin, indinavir, tipranavir, atazanavir, darunavir, fosamprenavir, saquinavir) and what condition you are using it to treat.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21"
    },
    {
      id: "q18",
      apiKey: "meds_alpha_blockers_selected",
      apiKey2: "meds_alpha_blockers_conditions",
      type: "multiselect-textarea",
      progress: 34,
      showBack: true,
      heading: "Please tell us which of these medications you take",
      heading2: "What condition you are using it to treat.",
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Doxazosin", value: "doxazosin" },
        { label: "Tamsulosin", value: "tamsulosin" },
        { label: "Alfuzosin", value: "alfuzosin" },
        { label: "Terazosin", value: "terazosin" },
        { label: "Prazosin", value: "prazosin" }
      ]
    },
    {
      id: "q18b",
      apiKey: "meds_rifampicin_hiv_pi_selected",
      apiKey2: "meds_rifampicin_hiv_pi_conditions",
      type: "multiselect-textarea",
      progress: 37,
      showBack: true,
      heading: "Please tell us which of these medications you take",
      heading2: "What condition you are using it to treat.",
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Rifampicin", value: "rifampicin" },
        { label: "Indinavir", value: "indinavir" },
        { label: "Tipranavir", value: "tipranavir" },
        { label: "Atazanavir", value: "atazanavir" },
        { label: "Darunavir", value: "darunavir" },
        { label: "Fosamprenavir", value: "fosamprenavir" },
        { label: "Saquinavir", value: "saquinavir" }
      ]
    },
    {
      id: "q19",
      apiKey: "meds_diltiazem_group_selected",
      apiKey2: "meds_diltiazem_group_conditions",
      type: "multiselect-textarea",
      progress: 39,
      showBack: true,
      heading: "Please tell us which of these medications you take",
      heading2: "What condition you are using it to treat.",
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Diltiazem", value: "diltiazem" },
        { label: "Verapamil", value: "verapamil" },
        { label: "Amiodarone", value: "amiodarone" }
      ]
    },
    {
      id: "q20",
      apiKey: "meds_tki_selected",
      apiKey2: "meds_tki_conditions",
      type: "multiselect-textarea",
      progress: 39,
      showBack: true,
      heading: "Please tell us which of these medications you take",
      heading2: "What condition you are using it to treat.",
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q21",
      options: [
        { label: "Nilotinib", value: "nilotinib" },
        { label: "Lapatinib", value: "lapatinib" },
        { label: "Pazopanib", value: "pazopanib" },
        { label: "Sunitinib", value: "sunitinib" }
      ]
    },
    {
      id: "q21",
      apiKey: "previous_ed_treatments",
      type: "multiselect-selector",
      exclusiveValues: ["none", "other"],
      progress: 32,
      showBack: true,
      heading: "Have you taken, or are you currently taking any of the following erectile dysfunction treatments?",
      buttonLabel: "Next",
      next: "q31",
      options: [
        { label: "Viagra / Sildenafil", value: "viagra" },
        { label: "Cialis / Tadalafil", value: "cialis" },
        { label: "Levitra / Vardenafil", value: "levitra" },
        { label: "Spedra / Avanafil", value: "spedra" },
        { label: "Penile Pumps", value: "penile-pumps" },
        { label: "Penile Injections (Caverject / Edex / Prostin VR)", value: "penile-injections" },
        { label: "Herbal / Ayurvedic Remedies", value: "herbal" },
        { label: "Other", value: "other" },
        { label: "None of the above", value: "none" }
      ]
    },
    {
      id: "q21a",
      apiKey: "viagra_highest_dose",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "What was the highest dose of {q21} that you took?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Viagra / Sildenafil 25mg Tablets", value: "25mg", next: "q21b" },
        { label: "Viarga / Viagra Connect / Sildenafil 50mg Tablets", value: "50mg", next: "q21b" },
        { label: "Viagra / Sildenafil 100mg Tablets", value: "100mg", next: "q21b" }
      ]
    },
    {
      id: "q21b",
      apiKey: "viagra_expectations_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Did {q21a} meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "q21d" },
        { label: "No", value: "no", next: "q21c" }
      ]
    },
    {
      id: "q21c",
      apiKey: "viagra_why_not_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Why did {q21a} not meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "It wasn\u2019t effective", value: "not-effective", next: "q21d" },
        { label: "I experienced side effects", value: "side-effects", next: "q21d" },
        { label: "I didn\u2019t like having to plan for sex", value: "plan-sex", next: "q21d" }
      ]
    },
    {
      id: "q21d",
      apiKey: "viagra_duration_25mg",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "How long did you take {q21a} for?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Less than a month", value: "less-month", next: "q21e" },
        { label: "1-6 months", value: "1-6-months", next: "q21e" },
        { label: "Longer than 6 months", value: "longer-6-months", next: "q21e" }
      ]
    },
    {
      id: "q21e",
      apiKey: "viagra_doses_taken",
      type: "selector",
      progress: 34,
      showBack: true,
      heading: "How many doses did you take?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "1", value: "1", next: "q31" },
        { label: "2-3", value: "2-3", next: "q31" },
        { label: "More than 3", value: "more-than-3", next: "q31" }
      ]
    },
    {
      id: "q22",
      apiKey: "cialis_highest_dose",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "What was the highest dose of {q21} that you took?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Cialis/ Tadalafil 2.5mg tablets", value: "2.5mg", next: "q22a" },
        { label: "Cialis/ Tadalafil 5mg tablets", value: "5mg", next: "q22a" },
        { label: "Cialis/ Tadalafil 10mg tablets", value: "10mg", next: "q22a" },
        { label: "Cialis/ Tadalafil 20mg tablets", value: "20mg", next: "q22a" }
      ]
    },
    {
      id: "q22a",
      apiKey: "cialis_expectations_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Did {q22} meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "q21e" },
        { label: "No", value: "no", next: "q22b" }
      ]
    },
    {
      id: "q22b",
      apiKey: "cialis_why_not_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Why did {q22} not meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "I expereinced side effects", value: "side-effects", next: "q31" },
        { label: "It wasn\u2019t effective", value: "not-effective", next: "q31" }
      ]
    },
    {
      id: "q23",
      apiKey: "levitra_expectations_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Did {q21} meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "q31" },
        { label: "No", value: "no", next: "q23a" }
      ]
    },
    {
      id: "q23a",
      apiKey: "levitra_why_not_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Why did {q21} not meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "It wasn\u2019t effective", value: "not-effective", next: "q31" },
        { label: "I experienced side effects", value: "side-effects", next: "q31" },
        { label: "I didn\u2019t like having to plan for sex", value: "plan-sex", next: "q31" }
      ]
    },
    {
      id: "q24",
      apiKey: "spedra_expectations_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Did {q21} meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "q31" },
        { label: "No", value: "no", next: "q24a" }
      ]
    },
    {
      id: "q24a",
      apiKey: "spedra_why_not_met",
      type: "selector",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Why did {q21} not meet your expectations?",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "It wasn\u2019t effective", value: "not-effective", next: "q31" },
        { label: "I experienced side effects", value: "side-effects", next: "q31" },
        { label: "I didn\u2019t like having to plan for sex", value: "plan-sex", next: "q31" }
      ]
    },
    {
      id: "q25",
      apiKey: "penile_pumps_details",
      type: "textarea",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Please tell us more about your experience with {q21}, including how long you’ve used them and how effective they’ve been for you.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q31"
    },
    {
      id: "q26",
      apiKey: "penile_injections_details",
      type: "textarea",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Please tell us more about your experience with {q21}, including how long you\u2019ve used them and how effective they\u2019ve been for you.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q31"
    },
    {
      id: "q28",
      apiKey: "herbal_ayurvedic_details",
      type: "textarea",
      progress: 34,
      showBack: true,
      dynamicHeading: true,
      heading: "Please tell us more about your experience with {q21}, including how long you\u2019ve used them and how effective they\u2019ve been for you.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q31"
    },
    {
      id: "q29",
      apiKey: "ed_treatment_other_details",
      type: "textarea",
      progress: 34,
      showBack: true,
      heading: "Please tell us more about the erectile dysfunction treatments you've tried, including how long you've used them and how effective they've been for you.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q31"
    },
    {
      id: "q31",
      apiKey: "medical_history_statement",
      type: "selector",
      progress: 34,
      showBack: true,
      heading: "It\u2019s really important to tell us about your past medical history such as",
      bulletPoints: [
        "major illnesses",
        "surgeries",
        "ongoing medical conditions",
        "any medication prescribed or over the counter",
        "allergies to medication"
      ],
      headingAfter: "This information allows us to advise on the safest and most appropriate treatment for you.",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "I have a major illness, surgeries, ongoing medical condition, take prescribed or over the counter medication and allergies to medication(s).", value: "yes", next: "q31a" },
        { label: "I do not have a major illness, surgeries, ongoing medical condition, take prescribed or over the counter medication and allergies to medication(s).", value: "no", next: "q31c" }
      ]
    },
    {
      id: "q31a",
      apiKey: "medical_history_details",
      type: "textarea",
      progress: 34,
      showBack: true,
      heading: "Please tell us about your major illness, surgeries, ongoing medical condition, take prescribed or over the counter medication and allergies to medication(s). This information allows us to advise on the safest and most appropriate treatment for you.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q31b"
    },
    {
      id: "q31b",
      apiKey: "current_medications_list",
      type: "textarea",
      progress: 34,
      showBack: true,
      heading: "Please list of any medications you are currently taking. This information allows us to advise on the safest and most appropriate treatment for you.",
      required: true,
      placeholder: "Start from here",
      buttonLabel: "Next",
      next: "q31c"
    },
    {
      id: "q31c",
      apiKey: "inform_gp",
      type: "selector",
      progress: 34,
      showBack: true,
      heading: "Would you like your GP to be informed of this consultation? To help us provide safe and coordinated care, we recommend sharing your GP details so they can be kept informed",
      showButton: true,
      buttonLabel: "Next",
      options: [
        { label: "Yes", value: "yes", next: "q31d" },
        { label: "No", value: "no", next: "q0" }
      ]
    },
    {
      id: "q31d",
      apiKey: "gp_email",
      type: "email",
      progress: 34,
      showBack: true,
      heading: "Please enter your GP\u2019s email address",
      required: true,
      placeholder: "Your GP\u2019s email address",
      buttonLabel: "Next",
      next: "q0"
    },
    {
      id: "q0",
      type: "basic-info",
      progress: 35,
      showBack: true,
      heading: "Basic Information",
      fields: [
        { key: "first_name", label: "First name", type: "text", required: true, placeholder: "First name", half: true },
        { key: "last_name", label: "Last name", type: "text", required: true, placeholder: "Last name", half: true },
        { key: "patient_email", label: "Email", type: "email", required: true, placeholder: "Email" }
      ],
      buttonLabel: "Submit",
      next: "recommendation-loading"
    },
    {
      id: "recommendation-loading",
      type: "loading",
      heading: "We are creating a personalised recommendation for you!",
      subheading: "This will only take a couple of seconds",
      duration: 3000,
      next: "assessment-complete"
    },
    {
      id: "assessment-complete",
      type: "message",
      heading: "Thank you",
      subheading: "Your assessment has been submitted.",
      redirectUrl: "https://getadrip.shop/pages/plp-ed",
      redirectDelay: 3000,
      buttonLabel: "Continue now",
      buttonAction: "redirect-now"
    },
    {
      id: "not-eligible",
      type: "message",
      heading: "Unfortunately, based on your answers, we are unable to prescribe this treatment for you at this time.",
      subheading: "We recommend speaking with your GP for further advice and alternative options.",
      buttonLabel: "Start Again",
      buttonAction: "restart"
    }
  ]
};
